<script lang="ts">
    import { cn } from "@/lib/utils";
    let className: string = undefined
    export {className as class}
    export let headerClass: string = undefined
    export let bodyClass: string = undefined

</script>

<div class={cn("grid grid-rows-[min-content,11rem,1fr] grid-flow-row border border-xerteal-800/50 rounded overflow-clip", className)}>
    <div class={cn("row-start-1 col-start-1 z-10", headerClass)}>
        <slot name="header"/>
    </div>
    <div class="row-start-1 col-start-1 row-span-2">
        <slot name="banner">
            <div class="header-background w-full h-full rounded-t"/>
        </slot>
    </div>
    <div class={cn("md:px-6 md:pb-8 lg:px-10 lg:pb-12 row-start-2 col-start-1 row-span-2", bodyClass)}>
        <slot name="body"/>
    </div>
</div>

<style lang="scss">

    .header-background {
        background: linear-gradient(0deg, rgba(var(--rgb-xert-teal), 0.75) 0%, rgba(var(--rgb-xert-teal), 0.75) 100%), url("../../assets/images/Hero-Carousel-4-bg.jpg");
        background-position: top right;
    }

</style>